import { Modal, MODULE_TYPE } from '@abiglobalhealth/go-types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react'

import { useModule } from '@/hooks/useModule'

export interface ModalContextProps {
  modal: Modal | null
  openModal: (modalId: string) => void
  checkBoxModal: {
    opened: boolean
    url?: string
  }
  setCheckBoxModal: Dispatch<
    SetStateAction<{
      opened: boolean
      url?: string | undefined
    }>
  >
  closeModal: () => void
}

export const ModalContext = createContext({} as ModalContextProps)

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const { currentModule } = useModule()
  const [modal, setModal] = useState<ModalContextProps['modal']>(null)
  const [checkBoxModal, setCheckBoxModal] = useState<ModalContextProps['checkBoxModal']>({
    opened: false
  })

  const closeModal = () => setModal(null)
  const openModal = (modalId: string) => {
    if (currentModule?.type !== MODULE_TYPE.DEFAULT) return

    if (!currentModule?.modals) throw new Error('No modals found in current module')
    setModal(currentModule.modals[modalId])
  }

  const value = {
    modal,
    openModal,
    closeModal,
    checkBoxModal,
    setCheckBoxModal
  }

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}
